import Axios from "axios";

export default {
    birthPrice: () => {
        return Axios.get('/BirthDoc/doc-price/')
    },

    birthFirstTimeRecordPrice: () => {
        return Axios.get('/BirthDoc/doc-price-first-time/')
    },

    deathPrice: () => {
        return Axios.get('/DeathDoc/doc-price/')
    },

    nidPrice: () => {
        return Axios.get('/NidDoc/doc-price/')
    },
    nidFormPrice: (DocumentTypeCode) => {
        return Axios.get('/NidForm/doc-price/' , {headers : {"DocumentTypeCode": DocumentTypeCode}})
    },

    marriagePrice: () => {
        return Axios.get('/MarriageDoc/doc-price/')
    },

    divorcePrice: () => {
        return Axios.get('/DivorceDoc/doc-price/')
    },

    familyRecordPrice: () => {
        return Axios.get('/FamilyRecordDoc/doc-price/')
    },

    personalRecordPrice: () => {
        return Axios.get('/PersonalRecordDoc/doc-price/')
    },

    translatedDocPrice: () => {
        return Axios.get('/TranslatedDoc/doc-price/')
    },
}